import { defineStore } from 'pinia';



export const useDonationStore = defineStore('Donation', {
    state: () => ({
        id: null,
        id_module: null,
        actif: false,
        montant_libre: false,
        montants_proposes: "",
        beneficiaire: "",
        url_beneficiaire: "",
        description: "",
    }),
    actions: {
        set(data) {
            if (!data) return;
            this.id = data.id;
            this.id_module = data.id_module;
            this.actif = data.actif;
            this.montant_libre = data.montant_libre;
            this.montants_proposes = data.montants_proposes;
            this.beneficiaire = data.beneficiaire;
            this.url_beneficiaire = data.url_beneficiaire;
            this.description = data.description;
        }
    },
    getters: {

    },
});